import { Dictionary } from 'ts-essentials'
import { CSSObject, SerializedStyles } from '@emotion/css'

interface ThemeColors {
  bg: string
  content: string
  contentAlt: string
  link: string
  linkActive: string
}

interface ThemeFonts {
  display?: Styles
  heading?: Styles
  regular: Styles
  small: Styles
  link?: Styles
}

type Styles = CSSObject | SerializedStyles

export type ThemeColor = keyof ThemeColors
export type ThemeFont = keyof ThemeFonts

export class Theme {
  public constructor(readonly colors: ThemeColors, readonly fonts: ThemeFonts) {
    this.color = this.color.bind(this)
    this.font = this.font.bind(this)

    this.colors = colors
    this.fonts = fonts
  }

  public color(color: string): string
  public color(color: string | undefined): string | undefined
  public color(color: string | undefined): string | undefined {
    if (!color) {
      return undefined
    }

    return ((this.colors as unknown) as Dictionary<string>)[color] || color
  }

  public font(font: string | ThemeFont): Styles
  public font(font: string | ThemeFont | undefined): Styles | undefined
  public font(font: ThemeFont | undefined): unknown {
    if (!font) {
      return undefined
    }

    return ((this.fonts as unknown) as Dictionary<string>)[font] || font
  }
}

export type Themed<T = {}> = T & { theme: Theme }
